var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCircle(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 33.1199C9.64788 33.1199 2.87988 26.3519 2.87988 17.9999C2.87988 9.64788 9.64788 2.87988 17.9999 2.87988C26.3519 2.87988 33.1199 9.64788 33.1199 17.9999C33.1199 26.3519 26.3519 33.1199 17.9999 33.1199ZM17.9999 7.19988C12.0239 7.19988 7.19988 12.0239 7.19988 17.9999C7.19988 23.9759 12.0239 28.7999 17.9999 28.7999C23.9759 28.7999 28.7999 23.9759 28.7999 17.9999C28.7999 12.0239 23.9759 7.19988 17.9999 7.19988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19988 17.9999H2.87988C2.87988 9.64788 9.64788 2.87988 17.9999 2.87988V7.19988C12.0239 7.19988 7.19988 12.0239 7.19988 17.9999Z",
    fill: "#9E9E9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCircle);
export default __webpack_public_path__ + "static/media/UploadCircle.5a7bc6ec3a2a732c234cba7ca2cb06ce.svg";
export { ForwardRef as ReactComponent };